module.exports = __webpack_public_path__ + "18e8a227a45200474edcffcc684a51d1.MP3";